import React, { useReducer, createContext, Dispatch } from 'react';

interface DrawerState {
  isOpen: boolean;
}

type DrawerAction = { type: 'TOGGLE' };

interface DrawerContextValue {
  state: DrawerState;
  dispatch: Dispatch<DrawerAction>;
}

const initialState: DrawerState = {
  isOpen: false,
};

function reducer(state: DrawerState, action: DrawerAction): DrawerState {
  switch (action.type) {
    case 'TOGGLE':
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    default:
      return state;
  }
}

export const DrawerContext = createContext<DrawerContextValue | undefined>(
  undefined
);

interface DrawerProviderProps {
  children: React.ReactNode;
}

export const DrawerProvider: React.FC<DrawerProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <DrawerContext.Provider value={{ state, dispatch }}>
      {children}
    </DrawerContext.Provider>
  );
};
